module.exports = __webpack_public_path__ + "img/detail-banner-title.b2dbfe23.png";